"use client";

import React from "react";
import { motion } from "framer-motion";
import { BadgeCheck, FileText, Lock, RefreshCw } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  icon: BadgeCheck,
  title: "Data Resmi & Terverifikasi",
  description: "Setiap informasi berasal dari dokumen resmi organisasi dan telah diverifikasi."
}, {
  icon: FileText,
  title: "Sumber Terpercaya",
  description: "Bersumber dari SK, arsip resmi, buku sejarah, dan dokumen MPN / MPW / MPC."
}, {
  icon: Lock,
  title: "Privasi Terjaga",
  description: "Data sensitif tidak ditampilkan publik dan dikelola sesuai kebijakan organisasi."
}, {
  icon: RefreshCw,
  title: "Perubahan Data",
  description: "Jika ada koreksi atau pembaruan data, silakan hubungi admin wilayah."
}];
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};
export default function ServiceBenefitsGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="servicebenefitsgrid" className="bg-background border-t border-border py-12" ref={ref}>
      <div className="container mx-auto px-4 md:px-6">
        <motion.div variants={containerVariants} initial="hidden" animate={isVisible ? "show" : "hidden"} className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4 lg:gap-0">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <motion.div key={i} data-index={i} variants={itemVariants} className={`flex flex-col sm:flex-row gap-4 items-start ${i !== 0 ? "lg:border-l lg:border-border lg:pl-8" : ""} ${i !== benefits.length - 1 ? "lg:pr-8" : ""}`}>
                <div className="shrink-0 text-primary bg-primary/10 p-3 rounded-lg">
                  <Icon className="size-6" />
                </div>
                <div>
                  <h3 className="font-default font-semibold text-foreground text-base mb-2">
                    {benefit.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}